import { render } from "./ExceptionTable.vue?vue&type=template&id=436da6ff"
import script from "./ExceptionTable.vue?vue&type=script&lang=js"
export * from "./ExceptionTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__